window.EVerifyAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration.EVerifyServer);

    var closureReasonsMap = {};

    var _EVerifyHandleException = function (message) {
        this.message = message || 'Something went wrong!';
        this.name = 'EVerify Handle Exception';

        this.generateError = function (err) {
            if (err.data && err.data.data) {
                if (err.data.data[0] && err.data.data[0].error){
                    err.data = err.data.data[0];
                } else {
                    err.data = err;
                }
            }
            return err.data;
        };
    };

    self.getLateVerificationReasons = function () {
        var deferred = $q.defer();

        _protected.request("reasons/late_verification", 'GET')
            .then(function (result) {

                if (result && result.data && result.data.data && result.status == 200) {
                    if (Array.isArray(result.data.data.reasons)) {
                        deferred.resolve(result.data.data.reasons);
                    } else {
                        deferred.resolve([]);
                    }
                } else {
                    var errorHandle = new _EVerifyHandleException();

                    deferred.reject(errorHandle.generateError(result));
                }
            }, function (err) {
                var errorHandle = new _EVerifyHandleException();

                deferred.reject(errorHandle.generateError(err));
            });

        return deferred.promise;
    };

    self.getCountriesLookup = function () {
        var deferred = $q.defer();

        _protected.request("countries", 'GET')
            .then(function (result) {

                if (result && result.data && result.data.data && result.status == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getClosureReasonsList = function () {
        var deferred = $q.defer();

        if (Object.keys(closureReasonsMap).length) {
            deferred.resolve(closureReasonsMap);
        } else {
            _protected.request("reasons/closure", 'GET')
                .then(function (result) {
                    if (result && result.data && result.data.data && result.status == 200) {
                        var reasons = result.data.data.reasons || [];

                        for (var i in reasons) {
                            closureReasonsMap[reasons[i].code] = reasons[i];
                        }

                        deferred.resolve(closureReasonsMap);
                    } else {
                        var errorHandle = new _EVerifyHandleException();

                        deferred.reject(errorHandle.generateError(result));
                    }
                }, function (err) {
                    var errorHandle = new _EVerifyHandleException();

                    deferred.reject(errorHandle.generateError(err));
                });
        }

        return deferred.promise;
    };

    self.getUsersTrustIdStatuses = function(brandId, userIds) {
        var deferred = $q.defer();

        userIds = userIds || [];

        if (!brandId) {
            throw new _EVerifyHandleException("No Brand Id");
        }
        _protected.request("brands/" + brandId + "/users/statuses", 'GET', {user_ids: userIds})
            .then(function (result) {

                if (result && result.data && result.data.data && result.status == 200) {
                    if (Array.isArray(result.data.data.users)) {
                        deferred.resolve(result.data.data.users);
                    } else {
                        deferred.resolve([]);
                    }
                } else {
                    var errorHandle = new _EVerifyHandleException();

                    deferred.reject(errorHandle.generateError(result));
                }
            }, function (err) {
                var errorHandle = new _EVerifyHandleException();

                deferred.reject(errorHandle.generateError(err));
            });

        return deferred.promise;
    }

    self.getCasesStatusForUsers = function (brand_id, job_id, userIds) {
        var deferred = $q.defer();

        userIds = userIds || [];

        if (!brand_id) {
            throw new _EVerifyHandleException("No Brand Id");
        } else if (!job_id) {
            throw new _EVerifyHandleException("No Job Id");
        }

        _protected.request("brands/" + brand_id + "/jobs/" + job_id + "/statuses", 'GET', {user_ids: userIds})
            .then(function (result) {

                if (result && result.data && result.data.data && result.status == 200) {
                    if (Array.isArray(result.data.data.users)) {
                        deferred.resolve(result.data.data.users);
                    } else {
                        deferred.resolve([]);
                    }
                } else {
                    var errorHandle = new _EVerifyHandleException();

                    deferred.reject(errorHandle.generateError(result));
                }
            }, function (err) {
                var errorHandle = new _EVerifyHandleException();

                deferred.reject(errorHandle.generateError(err));
            });

        return deferred.promise;
    };

    self.getUsersBrandCases = function (brand_id, userIds) {
        var deferred = $q.defer();

        userIds = userIds || [];

        if (!brand_id) {
            throw new _EVerifyHandleException("No Brand Id");
        }
        _protected.request("brands/" + brand_id + "/users/cases", 'GET', {user_ids: userIds})
            .then(function (result) {

                if (result && result.data && result.data.data && result.status == 200) {
                    if (Array.isArray(result.data.data.users)) {
                        deferred.resolve(result.data.data);
                    } else {
                        deferred.resolve([]);
                    }
                } else {
                    var errorHandle = new _EVerifyHandleException();

                    deferred.reject(errorHandle.generateError(result));
                }
            }).catch(function(){
            deferred.reject(errorHandle.generateError(err));
        });


        return deferred.promise;
    };

    self.startUserCase = function (brand_id, userId, caseId, late_reason, late_reason_other_txt, alien_number, phone_number, duplicate_reason, trust_id_answers, photo_confirmed) {
        var deferred = $q.defer();

        if (!brand_id) {
            throw new _EVerifyHandleException("No Brand Id");
        } else if (!userId) {
            throw new _EVerifyHandleException("No user id");
        } else if (!caseId) {
            throw new _EVerifyHandleException("No case id");
        }

        var data = {};

        if (late_reason) {
            data['late_reason_code'] = late_reason;
        }

        if (late_reason_other_txt) {
            data['late_reason_other_txt'] = late_reason_other_txt;
        }

        if (alien_number) {
            data['alien_number'] = alien_number;
        }

        if (phone_number) {
            data['phone_number'] = phone_number.replace(/\D/g, "");
        }

        if (duplicate_reason) {
            data['duplicate_reason'] = duplicate_reason;
        }

        if (trust_id_answers) {
            data['answers'] = trust_id_answers;
        }

        if (photo_confirmed) {
            data['photo_confirmed'] = photo_confirmed;
        }

        _protected.uniqueRequest("brands/" + brand_id + "/users/" + userId + "/cases/" + caseId + "/start", 'POST', data)
            .then(function (result) {

                if (result && result.data && result.data.data && result.status == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    var errorHandle = new _EVerifyHandleException();

                    deferred.reject(errorHandle.generateError(result));
                }
            }, function (err) {
                var errorHandle = new _EVerifyHandleException();

                deferred.reject(errorHandle.generateError(err));
            });

        return deferred.promise;
    };

    self.getCaseDetails = function (brand_id, userId, caseId) {
        var deferred = $q.defer();

        if (!brand_id) {
            throw new _EVerifyHandleException("No Brand Id");
        } else if (!userId) {
            throw new _EVerifyHandleException("No user id");
        } else if (!caseId) {
            throw new _EVerifyHandleException("No case id");
        }

        _protected.request("brands/" + brand_id + "/users/" + userId + "/cases/" + caseId, 'GET')
            .then(function (result) {

                if (result && result.data && result.data.data && result.status == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    var errorHandle = new _EVerifyHandleException();

                    deferred.reject(errorHandle.generateError(result));
                }
            }, function (err) {
                var errorHandle = new _EVerifyHandleException();

                deferred.reject(errorHandle.generateError(err));
            });

        return deferred.promise;
    };

    self.closeCase = function (brand_id, userId, caseId, otherReason, employmentReason,  closureReasonCode) {
        var deferred = $q.defer();

        if (!brand_id) {
            throw new _EVerifyHandleException("No Brand Id");
        } else if (!userId) {
            throw new _EVerifyHandleException("No user id");
        } else if (!caseId) {
            throw new _EVerifyHandleException("No case id");
        }

        var data = {
            closure_reason_code: closureReasonCode
        };

        if (otherReason) {
            data['other_reason_description'] = otherReason;
        }

        if (employmentReason) {
            data['currently_employed_reason_description'] = employmentReason;
        }

        _protected.uniqueRequest("brands/" + brand_id + "/users/" + userId + "/cases/" + caseId + "/close", 'POST', data)
            .then(function (result) {

                if (result && result.data && result.data.data && result.status == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    var errorHandle = new _EVerifyHandleException();

                    deferred.reject(errorHandle.generateError(result));
                }
            }, function (err) {
                var errorHandle = new _EVerifyHandleException();

                deferred.reject(errorHandle.generateError(err));
            });

        return deferred.promise;
    };

    self.getLatestEmployerPhoneNumber = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw new _EVerifyHandleException("No Brand Id");
        }

        _protected.request("brands/" + brandId + "/cases/creator_last_phone_number", 'GET')
            .then(function (result) {
                if (result && result.data && result.data.data && result.status == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    var errorHandle = new _EVerifyHandleException();

                    deferred.reject(errorHandle.generateError(result));
                }
            }, function (err) {
                var errorHandle = new _EVerifyHandleException();

                deferred.reject(errorHandle.generateError(err));
            });

        return deferred.promise;
    };

    self.getLettersS3Path = function (brand_id, userId, caseId, letterCode, languageCode) {
        var deferred = $q.defer();

        if (!brand_id) {
            throw new _EVerifyHandleException("No Brand Id");
        } else if (!userId) {
            throw new _EVerifyHandleException("No user id");
        } else if (!caseId) {
            throw new _EVerifyHandleException("No case id");
        } else if (!letterCode) {
            throw new _EVerifyHandleException("No Letter code");
        } else if (!languageCode) {
            throw new _EVerifyHandleException("No language code");
        }

        _protected.request("brands/" + brand_id + "/users/" + userId + "/cases/" + caseId + "/letters/" + letterCode, 'GET', {language: languageCode})
            .then(function (result) {

                if (result && result.data && result.data.data && result.status == 200) {
                    deferred.resolve(result.data.data.href);
                } else {
                    var errorHandle = new _EVerifyHandleException();

                    deferred.reject(errorHandle.generateError(result));
                }
            }, function (err) {
                var errorHandle = new _EVerifyHandleException();

                deferred.reject(errorHandle.generateError(err));
            });

        return deferred.promise;
    };

    self.getDuplicateReasons = function () {
        var deferred = $q.defer();

        _protected.request('reasons/duplicate_continuance', 'GET')
            .then(function (result) {

                if (result && result.data && result.data.data && result.status == 200) {
                    if (Array.isArray(result.data.data.reasons)) {
                        deferred.resolve(result.data.data.reasons);
                    } else {
                        deferred.resolve([]);
                    }
                } else {
                    var errorHandle = new _EVerifyHandleException();

                    deferred.reject(errorHandle.generateError(result));
                }
            }, function (err) {
                var errorHandle = new _EVerifyHandleException();

                deferred.reject(errorHandle.generateError(err));
            });

        return deferred.promise;
    };

    self.continueDuplicateCase = function (brand_id, userId, caseId, reasonCode, otherText) {
        var deferred = $q.defer();

        if (!brand_id) {
            throw new _EVerifyHandleException("No Brand Id");
        } else if (!userId) {
            throw new _EVerifyHandleException("No user id");
        } else if (!caseId) {
            throw new _EVerifyHandleException("No case id");
        } else if (!reasonCode) {
            throw new _EVerifyHandleException("No Reason id");
        }

        var data = {
            reason_code: reasonCode
        };

        if (otherText) {
            data['other_text'] = otherText;
        }

        _protected.uniqueRequest("brands/" + brand_id + "/users/" + userId + "/cases/" + caseId + "/continue_duplicate", 'POST', data)
            .then(function (result) {

                if (result && result.data && result.data.data && result.status == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    var errorHandle = new _EVerifyHandleException();

                    deferred.reject(errorHandle.generateError(result));
                }
            }, function (err) {
                var errorHandle = new _EVerifyHandleException();

                deferred.reject(errorHandle.generateError(err));
            });

        return deferred.promise;
    };

    self.getCaseClosureReasons = function (brand_id, userId, caseId) {
        var deferred = $q.defer();

        if (!brand_id) {
            throw new _EVerifyHandleException("No Brand Id");
        } else if (!userId) {
            throw new _EVerifyHandleException("No user id");
        } else if (!caseId) {
            throw new _EVerifyHandleException("No case id");
        }

        _protected.request("brands/" + brand_id + "/users/" + userId + "/cases/" + caseId + "/reasons/closure", 'GET')
            .then(function (result) {

                if (result && result.data && result.data.data && result.status == 200) {
                    if (Array.isArray(result.data.data.reasons)) {
                        deferred.resolve(result.data.data.reasons);
                    } else {
                        deferred.resolve([]);
                    }
                } else {
                    var errorHandle = new _EVerifyHandleException();

                    deferred.reject(errorHandle.generateError(result));
                }
            }, function (err) {
                var errorHandle = new _EVerifyHandleException();

                deferred.reject(errorHandle.generateError(err));
            });

        return deferred.promise;
    };

    self.getPhotoToConfirm = function (brand_id, userId, caseId) {
        var deferred = $q.defer();

        if (!brand_id) {
            throw new _EVerifyHandleException("No Brand Id");
        } else if (!userId) {
            throw new _EVerifyHandleException("No user id");
        } else if (!caseId) {
            throw new _EVerifyHandleException("No case id");
        }

        _protected.request("brands/" + brand_id + "/users/" + userId + "/cases/" + caseId + "/photo", 'GET')
            .then(function (result) {

                if (result && result.data && result.data.data && result.status == 200) {
                    deferred.resolve(result.data.data.href);
                } else {
                    var errorHandle = new _EVerifyHandleException();

                    deferred.reject(errorHandle.generateError(result));
                }
            }, function (err) {
                var errorHandle = new _EVerifyHandleException();

                deferred.reject(errorHandle.generateError(err));
            });

        return deferred.promise;
    };

    self.confirmMatchingPhoto = function (brand_id, userId, caseId, match_mode) {
        var deferred = $q.defer();

        if (!brand_id) {
            throw new _EVerifyHandleException("No Brand Id");
        } else if (!userId) {
            throw new _EVerifyHandleException("No user id");
        } else if (!caseId) {
            throw new _EVerifyHandleException("No case id");
        }

        var data = {
            photo_match_mode: match_mode
        };

        _protected.request("brands/" + brand_id + "/users/" + userId + "/cases/" + caseId + "/confirm_photo", 'POST', data)
            .then(function (result) {

                if (result && result.data && result.data.data && result.status == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    var errorHandle = new _EVerifyHandleException();

                    deferred.reject(errorHandle.generateError(result));
                }
            }, function (err) {
                var errorHandle = new _EVerifyHandleException();

                deferred.reject(errorHandle.generateError(err));
            });

        return deferred.promise;
    };
    self.completeTrustIdImposterCheck = async (brandId, userId, caseId, payload) => {
        try {
            if (!brandId) {
                throw "Brand id is required";
            }

            if (!userId) {
                throw "user id must be sent";
            }

            const response = await _protected.request('brands/' + brandId + '/users/' + userId + '/cases/' + caseId + '/imposter_checks', 'POST', payload);
                if (response.data && response.data.data && response.status === 200) {
                return response.data.data;
            } else {
                throw response;
            }
        } catch (err) {
            throw err;
        }
    };

    self.getCasesForUsersPerBrandId = function (brand_id, userId, jobId, latestCases) {
        var deferred = $q.defer();

        if (!brand_id) {
            throw new _EVerifyHandleException("No Brand Id");
        } else if (!userId) {
            throw new _EVerifyHandleException("No user id");
        }

        let params = {
            latest: latestCases,
        }

        _protected.request("brands/" + brand_id + "/users/" + userId + "/cases", 'GET', params)
            .then(function (result) {

                if (result && result.data && result.data.data && result.status == 200) {
                    if (Array.isArray(result.data.data.cases)) {
                        if (jobId) {
                            var filteredCases = _.filter(angular.copy(result.data.data.cases), function (item) {
                                return item.job_id === parseInt(jobId);
                            });

                            deferred.resolve(filteredCases);
                        }
                        else {
                            deferred.resolve(result.data.data.cases);
                        }
                    } else {
                        deferred.resolve([]);
                    }
                } else {
                    var errorHandle = new _EVerifyHandleException();

                    deferred.reject(errorHandle.generateError(result));
                }
            }, function (err) {
                var errorHandle = new _EVerifyHandleException();

                deferred.reject(errorHandle.generateError(err));
            });

        return deferred.promise;
    };

    self.getCasesHistory = async (brandId, userId) => {
        let defer = $q.defer();

        if (!brandId || !userId) {
            throw 'Brand id and user id are required';
        }

        _protected.request(`brands/${brandId}/users/${userId}/cases_history`, 'GET')
            .then((res) => {
                if (res.status === 200 && res.data?.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch((err) => {
                defer.reject(err);
            });

        return defer.promise;
    }

    self.resubmitCase = function (brand_id, userId, caseId) {
        var deferred = $q.defer();

        if (!brand_id) {
            throw new _EVerifyHandleException("No Brand Id");
        } else if (!userId) {
            throw new _EVerifyHandleException("No user id");
        } else if (!caseId) {
            throw new _EVerifyHandleException("No case id");
        }

        _protected.request("brands/" + brand_id + "/users/" + userId + "/cases/" + caseId + "/resubmit", 'POST')
            .then(function (result) {

                if (result && result.data && result.data.data && result.status == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    var errorHandle = new _EVerifyHandleException();

                    deferred.reject(errorHandle.generateError(result));
                }
            }, function (err) {
                var errorHandle = new _EVerifyHandleException();

                deferred.reject(errorHandle.generateError(err));
            });

        return deferred.promise;
    };

    self.startMultipleCases = function (brand_id, userId, caseIds) {
        var deferred = $q.defer();

        if (!brand_id) {
            throw new _EVerifyHandleException("No Brand Id");
        } else if (!userId) {
            throw new _EVerifyHandleException("No user id");
        } else if (!caseIds) {
            throw new _EVerifyHandleException("No case id");
        }

        var data = {};
        data['ids'] = caseIds;

        _protected.request("brands/" + brand_id + "/users/" + userId + "/cases/start", 'POST', data)
            .then(function (result) {

                if (result && result.data && result.data.data && result.status == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    var errorHandle = new _EVerifyHandleException();

                    deferred.reject(errorHandle.generateError(result));
                }
            }, function (err) {
                var errorHandle = new _EVerifyHandleException();

                deferred.reject(errorHandle.generateError(err));
            });

        return deferred.promise;
    };

    self.downloadReportByCase = function (brandId, userId, caseId) {
        var deferred = $q.defer();

        _protected.request("brands/" + brandId + "/users/" + userId + "/cases/" + caseId + "/report", 'GET')
            .then(function (result) {
                if (result && result.data && result.data.data && result.data.data.report_url && result.status == 200) {
                    deferred.resolve(result.data.data.report_url);
                } else {
                    var errorHandle = new _EVerifyHandleException();

                    deferred.reject(errorHandle.generateError(result));
                }
            }, function (err) {
                var errorHandle = new _EVerifyHandleException();

                deferred.reject(errorHandle.generateError(err));
            });

        return deferred.promise;
    };

    self.deleteInProcessTrustIdCase = function (brandId, userId, caseId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw new _EVerifyHandleException("No Brand Id");
        }

        if (!userId) {
            throw new _EVerifyHandleException("No User Id");
        }

        if (!caseId) {
            throw new _EVerifyHandleException("No Case Id");
        }


        _protected.request("brands/" + brandId + "/users/" + userId + "/cases/" + caseId, 'DELETE')
            .then(function (result) {

                if (result && result.data && result.data.data && result.status == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    var errorHandle = new _EVerifyHandleException();

                    deferred.reject(errorHandle.generateError(result));
                }
            }, function (err) {
                var errorHandle = new _EVerifyHandleException();

                deferred.reject(errorHandle.generateError(err));
            });

        return deferred.promise;
    };

    self.getTrustIdQuestions = function (brandId, serviceCode) {
        var deferred = $q.defer();

        if (!brandId) {
            throw new _EVerifyHandleException("No Brand Id");
        } else if (!serviceCode) {
            throw new _EVerifyHandleException("No service code");
        }

        _protected.request("brands/" + brandId + "/channels/" + serviceCode + "/questions", 'GET')
            .then(function (result) {

                if (result && result.data && result.data.data && result.status == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    var errorHandle = new _EVerifyHandleException();

                    deferred.reject(errorHandle.generateError(result));
                }
            }, function (err) {
                var errorHandle = new _EVerifyHandleException();

                deferred.reject(errorHandle.generateError(err));
            });

        return deferred.promise;

    };

    self.getTrustIdConfirmationPhoto = function (brandId, userId, caseId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw new _EVerifyHandleException("No Brand Id");
        } else if (!userId) {
            throw new _EVerifyHandleException("No user id");
        } else if (!caseId) {
            throw new _EVerifyHandleException("No case id");
        }

        _protected.request("brands/" + brandId + "/users/" + userId + "/cases/" + caseId + "/confirmation_photo", 'GET')
            .then(function (result) {

                if (result && result.data && result.data.data && result.status == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    var errorHandle = new _EVerifyHandleException();

                    deferred.reject(errorHandle.generateError(result));
                }
            }, function (err) {
                var errorHandle = new _EVerifyHandleException();

                deferred.reject(errorHandle.generateError(err));
            });

        return deferred.promise;
    };

    self.startUserCaseTrustId = (brand_id, userId, jobId, startCase, prospectId, documentId, attachmentIds, shareCode, birthDate) => {
        var deferred = $q.defer();

        if (!brand_id) {
            throw new _EVerifyHandleException("No Brand Id");
        } else if (!userId) {
            throw new _EVerifyHandleException("No user id");
        }

        var data = {};

        if (startCase) {
            data['start_case'] = startCase;
        }

        if (jobId) {
            data['job_id'] = jobId;
        }

        if (prospectId) {
            data['prospect_id'] = prospectId;
        }

        if (documentId) {
            data['document_id'] = documentId;
        }

        if (attachmentIds) {
            data['attachment_ids'] = attachmentIds;
        }

        if (shareCode) {
            data['share_code'] = shareCode;
        }

        if (birthDate) {
            data['birth_date'] = birthDate;
        }

        _protected.uniqueRequest("brands/" + brand_id + "/users/" + userId + "/cases", 'POST', data)
            .then(function (result) {

                if (result && result.data && result.data.data && result.status == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    var errorHandle = new _EVerifyHandleException();

                    deferred.reject(errorHandle.generateError(result));
                }
            }, function (err) {
                var errorHandle = new _EVerifyHandleException();

                deferred.reject(errorHandle.generateError(err));
            });

        return deferred.promise;
    };

    self.getBrandServicesSettings = function (brandId, serviceCode) {
        var defer = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        _protected.request('brands/' + brandId + '/services/'+ serviceCode +'/settings', 'GET')
            .then(function (res) {
                if (res && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });
        return defer.promise;
    }

    self.getEverifyCasesForProspects = function (brandId, prospectsIds, latest) {
        var deferred = $q.defer();

        if (!brandId) {
            throw new _EVerifyHandleException("No Brand Id");
        }

        if (!prospectsIds) {
            throw new _EVerifyHandleException("No prospects ids");
        }

        var data = {
            prospect_ids: prospectsIds,
            latest: latest
        };

        _protected.request("brands/" + brandId + "/cases", 'GET', data)
            .then(function (result) {
                if (result && result.data && result.data.data && result.status == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    var errorHandle = new _EVerifyHandleException();
                    deferred.reject(errorHandle.generateError(result));
                }
            }, function (err) {
                var errorHandle = new _EVerifyHandleException();
                deferred.reject(errorHandle.generateError(err));
            });

        return deferred.promise;
    };

    self.furtherActionNotice = function (brandId, userId, caseId, employee_notified, employee_will_take_action) {
        var deferred = $q.defer();

        if (!brandId) {
            throw new _EVerifyHandleException("No Brand Id");
        } else if (!userId) {
            throw new _EVerifyHandleException("No user id");
        } else if (!caseId) {
            throw new _EVerifyHandleException("No case id");
        }

        var payload = {
            employee_notified: employee_notified,
            employee_will_take_action: employee_will_take_action
        };

        _protected.uniqueRequest("brands/" + brandId + "/users/" + userId + "/cases/" + caseId + "/further_action_notice", 'POST', payload)
            .then(function (result) {
                if (result && result.data && result.data.data && result.status == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    var errorHandle = new _EVerifyHandleException();

                    deferred.reject(errorHandle.generateError(result));
                }
            }, function (err) {
                var errorHandle = new _EVerifyHandleException();

                deferred.reject(errorHandle.generateError(err));
            });

        return deferred.promise;
    };

    self.confirmData = function (brandId, userId, caseId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw new _EVerifyHandleException("No Brand Id");
        } else if (!userId) {
            throw new _EVerifyHandleException("No user id");
        } else if (!caseId) {
            throw new _EVerifyHandleException("No case id");
        }

        _protected.uniqueRequest("brands/" + brandId + "/users/" + userId + "/cases/" + caseId + "/confirm_details", 'POST')
            .then(function (result) {
                if (result && result.data && result.data.data && result.status == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    var errorHandle = new _EVerifyHandleException();

                    deferred.reject(errorHandle.generateError(result));
                }
            }, function (err) {
                var errorHandle = new _EVerifyHandleException();

                deferred.reject(errorHandle.generateError(err));
            });

        return deferred.promise;
    };

    self.getDuplicatesCases = function (brandId, userId, caseId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw new _EVerifyHandleException("No Brand Id");
        }

        if (!userId) {
            throw new _EVerifyHandleException("No user id");
        }

        if (!caseId) {
            throw new _EVerifyHandleException("No case id");
        }

        _protected.request("brands/" + brandId + "/users/" + userId + "/cases/" + caseId + "/duplicates", 'GET')
            .then(function (result) {
                if (result && result.data && result.data.data && result.status == 200) {
                    deferred.resolve(result.data.data);
                } else {
                    var errorHandle = new _EVerifyHandleException();
                    deferred.reject(errorHandle.generateError(result));
                }
            }, function (err) {
                var errorHandle = new _EVerifyHandleException();
                deferred.reject(errorHandle.generateError(err));
            });

        return deferred.promise;
    };

    self.getBrandTrustIdSettings = function (brandId, trustIdType) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('candidates/brands/' + brandId + '/services/'+trustIdType +'/settings', 'GET')
            .then(function (res) {
                if (res && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getEverifyHiringRestrictions = function (brandId, userId, positionCode) {
        var deferred = $q.defer();

        if (!brandId) {
            throw new _EVerifyHandleException("No Brand Id");
        }

        if (!userId) {
            throw new _EVerifyHandleException("No user id");
        }

        if (!positionCode) {
            throw new _EVerifyHandleException("No position code");
        }

        var payload =  {
            position_code: positionCode
        }

        _protected.request("brands/" + brandId + "/users/" + userId + "/cases/hiring_restrictions", 'GET', payload)
            .then(function (result) {
                if (result && result.data && result.data.data && result.status === 200) {
                    deferred.resolve(result.data.data);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

});

EVerifyAPI.STATUSES = {};

//TODO: remove statues
EVerifyAPI.STATUSES.SSA_TNC = "SSA_TNC";
EVerifyAPI.STATUSES.DHS_TNC = "DHS_TNC";
EVerifyAPI.STATUSES.AUTHORIZED = "AUTHORIZED";
EVerifyAPI.STATUSES.DHS_UNAUTHORIZED = "DHS_UNAUTHORIZED";
EVerifyAPI.STATUSES.SSA_UNAUTHORIZED = "SSA_UNAUTHORIZED";
EVerifyAPI.STATUSES.NO_SHOW = "NO_SHOW";
EVerifyAPI.STATUSES.IN_CONTINUANCE = "IN_CONTINUANCE";
EVerifyAPI.STATUSES.IN_PROCESS = "IN_PROCESS";
EVerifyAPI.STATUSES.UNABLE_TO_PROCESS = "UNABLE_TO_PROCESS";
EVerifyAPI.STATUSES.DUPLICATE = "DUPLICATE";
EVerifyAPI.STATUSES.PHOTO_MATCHING_REQUIRED = "PHOTO_MATCHING_REQUIRED";
EVerifyAPI.STATUSES.REVIEW_UPDATE_EMPLOYEE = "REVIEW_UPDATE_EMPLOYEE";
EVerifyAPI.STATUSES.DHS_CASE_INCOMPLETE = "DHS_CASE_INCOMPLETE";
EVerifyAPI.STATUSES.SSA_CASE_INCOMPLETE = "SSA_CASE_INCOMPLETE";
EVerifyAPI.STATUSES.CANCELLED = "CANCELLED";
EVerifyAPI.STATUSES.UNKNOWN = "UNKNOWN";
EVerifyAPI.STATUSES.SSA_IN_CONTINUANCE = "SSA_IN_CONTINUANCE";
EVerifyAPI.STATUSES.DHS_IN_CONTINUANCE = "DHS_IN_CONTINUANCE";
EVerifyAPI.STATUSES.X_UNPROCESSABLE = "X_UNPROCESSABLE";
EVerifyAPI.STATUSES.NOT_VERIFIED = "NOT_VERIFIED";
EVerifyAPI.STATUSES.UNAUTHORIZED = "UNAUTHORIZED";
EVerifyAPI.STATUSES.AUTHORIZED_TIME_LIMITED = "AUTHORIZED_TIME_LIMITED";
EVerifyAPI.STATUSES.SENDING = "SENDING";
EVerifyAPI.STATUSES.CONDITIONAL_CONTINUOUS = "CONDITIONAL_CONTINUOUS";
EVerifyAPI.STATUSES.CONDITIONAL_TIME_LIMITED = "CONDITIONAL_TIME_LIMITED";
EVerifyAPI.STATUSES.EXPIRED = "EXPIRED";

EVerifyAPI.STATUSES.NOT_STARTED = "NOT_STARTED";
EVerifyAPI.STATUSES.DRAFT = "DRAFT";
EVerifyAPI.STATUSES.CLOSED = "CLOSED";
EVerifyAPI.STATUSES.UNCONFIRMED_DATA = "UNCONFIRMED_DATA";
EVerifyAPI.STATUSES.PHOTO_MATCH = "PHOTO_MATCH";
EVerifyAPI.STATUSES.SCAN_AND_UPLOAD = "SCAN_AND_UPLOAD";
EVerifyAPI.STATUSES.MANUAL_REVIEW = "MANUAL_REVIEW";
EVerifyAPI.STATUSES.PENDING_REFERRAL = "PENDING_REFERRAL";
EVerifyAPI.STATUSES.REFERRED = "REFERRED";
EVerifyAPI.STATUSES.QUEUED = "QUEUED";
EVerifyAPI.STATUSES.EMPLOYMENT_AUTHORIZED = "EMPLOYMENT_AUTHORIZED";
EVerifyAPI.STATUSES.FINAL_NONCONFIRMATION = "FINAL_NONCONFIRMATION";
EVerifyAPI.STATUSES.CLOSE_CASE_AND_RESUBMIT = "CLOSE_CASE_AND_RESUBMIT";

EVerifyAPI.ELIGIBILITY_EMPLOYMENT = {};

EVerifyAPI.ELIGIBILITY_EMPLOYMENT.EMPLOYMENT_AUTHORIZED = "EMPLOYMENT_AUTHORIZED";
EVerifyAPI.ELIGIBILITY_EMPLOYMENT.NOT_AUTHORIZED_EMPLOYMENT = "NOT_AUTHORIZED_EMPLOYMENT";
EVerifyAPI.ELIGIBILITY_EMPLOYMENT.RESUBMIT_CASE = "RESUBMIT_CASE";
EVerifyAPI.ELIGIBILITY_EMPLOYMENT.NO_SHOW = "NO_SHOW";
EVerifyAPI.ELIGIBILITY_EMPLOYMENT.NO_ACTION_FNC = "NO_ACTION_FNC";

EVerifyAPI.SSA_DHS_STATUSES = {};

EVerifyAPI.SSA_DHS_STATUSES.PENDING_REFERRAL = "PENDING_REFERRAL";
EVerifyAPI.SSA_DHS_STATUSES.NOT_REFERRED = "NOT_REFERRED";
EVerifyAPI.SSA_DHS_STATUSES.REFERRED = "REFERRED";
EVerifyAPI.SSA_DHS_STATUSES.CONTINUANCE = "CONTINUANCE";
EVerifyAPI.SSA_DHS_STATUSES.RESOLVED = "RESOLVED";

EVerifyAPI.PRINT_CODES = {};

EVerifyAPI.PRINT_CODES.SSA_FAN = 'SSA_FAN';
EVerifyAPI.PRINT_CODES.SSA_NATZ_FAN = 'SSA_NATZ_FAN';
EVerifyAPI.PRINT_CODES.SSA_FA_FAN = 'SSA_FA_FAN';
EVerifyAPI.PRINT_CODES.SSA_FNC = 'SSA_FNC';
EVerifyAPI.PRINT_CODES.DHS_FAN = 'DHS_FAN';
EVerifyAPI.PRINT_CODES.DHS_FNC = 'DHS_FNC';
EVerifyAPI.PRINT_CODES.SSA_RDC = 'SSA_RDC';
EVerifyAPI.PRINT_CODES.DHS_RDC = 'DHS_RDC';

EVerifyAPI.STATUSES_TEXT = {};
EVerifyAPI.STATUSES_TEXT[EVerifyAPI.STATUSES.NOT_STARTED] = "Start E-verify";
EVerifyAPI.STATUSES_TEXT[EVerifyAPI.STATUSES.SSA_TNC] = "SSA Tentative NonConfirmation";
EVerifyAPI.STATUSES_TEXT[EVerifyAPI.STATUSES.DHS_TNC] = "DHS Tentative NonConfirmation";
EVerifyAPI.STATUSES_TEXT[EVerifyAPI.STATUSES.AUTHORIZED] = "Employment Authorized";
EVerifyAPI.STATUSES_TEXT[EVerifyAPI.STATUSES.DHS_UNAUTHORIZED] = "Final NonConfirmation";
EVerifyAPI.STATUSES_TEXT[EVerifyAPI.STATUSES.SSA_UNAUTHORIZED] = "Final NonConfirmation";
EVerifyAPI.STATUSES_TEXT[EVerifyAPI.STATUSES.NO_SHOW] = "No Show";
EVerifyAPI.STATUSES_TEXT[EVerifyAPI.STATUSES.IN_PROCESS] = "Verification in Process";
EVerifyAPI.STATUSES_TEXT[EVerifyAPI.STATUSES.UNABLE_TO_PROCESS] = "Unable to process";
EVerifyAPI.STATUSES_TEXT[EVerifyAPI.STATUSES.DUPLICATE] = "Duplicate Case";
EVerifyAPI.STATUSES_TEXT[EVerifyAPI.STATUSES.REVIEW_UPDATE_EMPLOYEE] = "SSA Review Employee Data";
EVerifyAPI.STATUSES_TEXT[EVerifyAPI.STATUSES.DHS_CASE_INCOMPLETE] = "DHS Case Incomplete";
EVerifyAPI.STATUSES_TEXT[EVerifyAPI.STATUSES.SSA_CASE_INCOMPLETE] = "SSA Case Incomplete";
EVerifyAPI.STATUSES_TEXT[EVerifyAPI.STATUSES.PHOTO_MATCHING_REQUIRED] = "Photo Matching Required";
EVerifyAPI.STATUSES_TEXT[EVerifyAPI.STATUSES.SSA_IN_CONTINUANCE] = "SSA In Continuance";
EVerifyAPI.STATUSES_TEXT[EVerifyAPI.STATUSES.DHS_IN_CONTINUANCE] = "DHS In Continuance";
EVerifyAPI.STATUSES_TEXT[EVerifyAPI.STATUSES.X_UNPROCESSABLE] = "Close and Resubmit the case";
EVerifyAPI.STATUSES_TEXT[EVerifyAPI.STATUSES.NOT_VERIFIED] = "Not Verified";

EVerifyAPI.STATUSES_TEXT[EVerifyAPI.STATUSES.CLOSED] = "Closed";
EVerifyAPI.STATUSES_TEXT[EVerifyAPI.STATUSES.DRAFT] = "Drafted";
EVerifyAPI.STATUSES_TEXT[EVerifyAPI.STATUSES.UNCONFIRMED_DATA] = "Unconfirmed Data";
EVerifyAPI.STATUSES_TEXT[EVerifyAPI.STATUSES.PHOTO_MATCH] = "Photo Matching Required";
EVerifyAPI.STATUSES_TEXT[EVerifyAPI.STATUSES.SCAN_AND_UPLOAD] = "Scan and Upload";
EVerifyAPI.STATUSES_TEXT[EVerifyAPI.STATUSES.MANUAL_REVIEW] = "Case in Manual Review";
EVerifyAPI.STATUSES_TEXT[EVerifyAPI.STATUSES.PENDING_REFERRAL] = "Tentative NonConfirmation";
EVerifyAPI.STATUSES_TEXT[EVerifyAPI.STATUSES.REFERRED] = "Referred TNC";
EVerifyAPI.STATUSES_TEXT[EVerifyAPI.STATUSES.QUEUED] = "Case Being Processed";
EVerifyAPI.STATUSES_TEXT[EVerifyAPI.STATUSES.EMPLOYMENT_AUTHORIZED] = "Employment Authorized";
EVerifyAPI.STATUSES_TEXT[EVerifyAPI.STATUSES.FINAL_NONCONFIRMATION] = "Final Nonconfirmation";
EVerifyAPI.STATUSES_TEXT[EVerifyAPI.STATUSES.CLOSE_CASE_AND_RESUBMIT] = "Close case and resubmit";

EVerifyAPI.STATUSES_TEXT[EVerifyAPI.ELIGIBILITY_EMPLOYMENT.EMPLOYMENT_AUTHORIZED] = "Authorized";
EVerifyAPI.STATUSES_TEXT[EVerifyAPI.ELIGIBILITY_EMPLOYMENT.NOT_AUTHORIZED_EMPLOYMENT] = "Not Authorized";
EVerifyAPI.STATUSES_TEXT[EVerifyAPI.ELIGIBILITY_EMPLOYMENT.RESUBMIT_CASE] = "Resubmit Case";
EVerifyAPI.STATUSES_TEXT[EVerifyAPI.ELIGIBILITY_EMPLOYMENT.NO_SHOW] = "No Show";
EVerifyAPI.STATUSES_TEXT[EVerifyAPI.ELIGIBILITY_EMPLOYMENT.NO_ACTION_FNC] = "No Action FNC";

EVerifyAPI.SSA_DHS_TEXT = {};
EVerifyAPI.SSA_DHS_TEXT[EVerifyAPI.SSA_DHS_STATUSES.REFERRED] = "Referred";
EVerifyAPI.SSA_DHS_TEXT[EVerifyAPI.SSA_DHS_STATUSES.PENDING_REFERRAL] = "Pending Referred";
EVerifyAPI.SSA_DHS_TEXT[EVerifyAPI.SSA_DHS_STATUSES.NOT_REFERRED] = "Not Referred";
EVerifyAPI.SSA_DHS_TEXT[EVerifyAPI.SSA_DHS_STATUSES.CONTINUANCE] = "Continuance";
EVerifyAPI.SSA_DHS_TEXT[EVerifyAPI.SSA_DHS_STATUSES.RESOLVED] = "Resolved";

EVerifyAPI.EVERIFY_HIRING_RESTRICTION = {};
EVerifyAPI.EVERIFY_HIRING_RESTRICTION.NO_RESTRICTIONS = "NO_RESTRICTIONS";
EVerifyAPI.EVERIFY_HIRING_RESTRICTION.ALL = "ALL";
EVerifyAPI.EVERIFY_HIRING_RESTRICTION.CLOSED_ONLY = "CLOSED_ONLY";
EVerifyAPI.EVERIFY_HIRING_RESTRICTION.AUTHORIZED_ONLY = "AUTHORIZED_ONLY";
EVerifyAPI.EVERIFY_HIRING_RESTRICTION.AFTER_OPENING_CASE = "AFTER_OPENING_CASE";